const GET_VEHICLE_CAPACITY = 'GET_VEHICLE_CAPACITY';
const SET_VEHICLE_CAPACITY = 'SET_VEHICLE_CAPACITY';

export
{
    GET_VEHICLE_CAPACITY,
    SET_VEHICLE_CAPACITY
};
